import React, { FC } from 'react';
import { FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllModals } from '../../actions/modalActions';
import { getUserProfile } from '../../actions/userProfileActions';
import { ADD_USER_EMAIL_TOKENCLEAR } from '../../constants/actions/userActions';
import { DELIVERY_OPTION_MODAL, POSTBOXES_STATUS_MODAL } from '../../constants/documentTypes/modals/modals';
import useKeyboardEvent from '../../hooks/useKeyboardEvent';
import { modalMapper } from './helpers';
import * as StyledModals from './modals.styles';

interface Props {}

const Modals: FC<Props> = () => {
	const { modal } = useSelector(({ modalReducer }) => modalReducer);
	const dispatch = useDispatch<any>();
	const Modal = modalMapper[modal];

	const closeModal = () => {
		dispatch(closeAllModals());
		if (modal === 'VERIFY_EMAIL_SECURE_MODAL') {
			dispatch(getUserProfile());
			dispatch({ type: ADD_USER_EMAIL_TOKENCLEAR });
		}
		document.body.style.overflow = 'unset';
	};

	useKeyboardEvent('Escape', () => closeModal());

	if (!Modal) return null;
	return (
		<StyledModals.Wrapper>
			<StyledModals.ModalOverlay onClick={closeModal} />
			<StyledModals.ModalClose onClick={closeModal}>
				<FaTimes />
			</StyledModals.ModalClose>
			<StyledModals.WrapperInner bigModal={[DELIVERY_OPTION_MODAL, POSTBOXES_STATUS_MODAL].includes(modal)}>
				<Modal />
			</StyledModals.WrapperInner>
		</StyledModals.Wrapper>
	);
};

export default Modals;
